import { HTTP_GET, WebApiRequest } from "tools/webservice";
import { SAPerformance, SchedulingTimeByDaySummary, SchedulingTimeCardResponse } from "interfaces/Mueller.Business.Models";
import { Ref } from "react";

export const getSAEmployeeList = (supervisorInternetUserId: number, payPeriodId: number, successCallback: (data: SchedulingTimeCardResponse) => void, mountedRef: Ref<boolean>) => WebApiRequest({
  method: HTTP_GET,
  endpoint: `/scheduling-assistant/time-card/managers/${supervisorInternetUserId}/payperiods/${payPeriodId}/employees`,
  successCallback,
  mountedRef,
});

// send internetUserId = 0 to get summary for logged in user
export const getTimeLogByDaySummary = (internetUserId: number, payPeriodId: number, successCallback: (data: SchedulingTimeByDaySummary) => void, mountedRef: Ref<boolean>) => WebApiRequest({
  method: HTTP_GET,
  endpoint: `/scheduling-assistant/time-card/${internetUserId}/payperiods/${payPeriodId}/summary`,
  successCallback,
  mountedRef,
});

export const getSAPerformance = (internetUserId: number, payPeriodId: number, successCallback: (data: SAPerformance[]) => void, mountedRef: Ref<boolean>) => WebApiRequest({
  method: HTTP_GET,
  endpoint: `/scheduling-assistant/time-card/${internetUserId}/payperiods/${payPeriodId}/performance`,
  successCallback,
  mountedRef,
});
